import React from "react"
import apiDefinition from "../api/rest-openapi.json"
import SwaggerUI from "swagger-ui-react"
import {Typography} from "@mui/material"
import "swagger-ui-react/swagger-ui.css"
export const RestDocumentation = () => {
    return <div style={{maxWidth : "1400px", margin : "auto"}}>
        <SwaggerUI spec={apiDefinition} tryItOutEnabled={true} />
    </div>
}